import { useState, useEffect, useMemo } from 'react';

const DEFAULT_BREAKPOINTS = {
  small: 450,
  medium: 768,
};

const MOBILE_NAV_MAX = 1023;

export const useScreenSize = (customBreakpoints = DEFAULT_BREAKPOINTS) => {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });

  useEffect(() => {
    let frame = 0;
    const handleResize = () => {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        setScreenSize({
          width: window.innerWidth,
          height: window.innerHeight,
        });
      });
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      cancelAnimationFrame(frame);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  const isSmallScreen = useMemo(
    () => screenSize.width <= customBreakpoints.small,
    [screenSize.width, customBreakpoints.small],
  );

  const isMediumScreen = useMemo(
    () =>
      screenSize.width > customBreakpoints.small &&
      screenSize.width <= customBreakpoints.medium,
    [screenSize.width, customBreakpoints.small, customBreakpoints.medium],
  );

  const isLargeScreen = useMemo(
    () => screenSize.width > customBreakpoints.medium,
    [screenSize.width, customBreakpoints.medium],
  );

  const isCompact = useMemo(
    () => screenSize.width < customBreakpoints.medium,
    [screenSize.width, customBreakpoints.medium],
  );

  const isMobileNav = useMemo(
    () => screenSize.width <= MOBILE_NAV_MAX,
    [screenSize.width],
  );

  return {
    screenSize,
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isCompact,
    isMobileNav,
  };
};
